export default "__VITE_ASSET__24fa5ea1__"